export default __webpack_public_path__ + "static/media/Banner_UM.5f59f35a.png";